import $ from 'jquery';
import $script from 'scriptjs';
import CurrencyConverter from 'shopify-currency-converter';
import Navigation from '../components/Navigation';

function toggleSearch(e) {
  if ($('.search-toggle-button').hasClass('open') && $(e.target).hasClass('search-browse-parent-outline')) {
    $('.search-toggle-button').removeClass('open');
  } else {
    $('.search-browse-container').css({ top: $('.search-browse-parent-outline').height() });
    $('.search-toggle-button').addClass('open');
  }
}

function fireSearchSelect(e) {
  const $target = $(e.target);
  if ($target.val().length) {
    window.location = $target.val();
  }
}

export default class StaticHeader {
  constructor(section) {
    this.$el = $(section.el);
    this.data = section.data;
    this.navigation = new Navigation({ el: this.$el });
    this._bindEvents();

    if (this.data.currencySettings.enable) {
      const $scripts = $('[data-scripts]');
      $script($scripts.data('shopify-currencies-url'), () => this._initCurrency());
    }
  }


  _bindEvents() {
    this.events = [
      $('.search-toggle-button', this.$el).on('click.header', e => toggleSearch(e)),
      $('.shop-by-category', this.$el).on('change.header', e => fireSearchSelect(e)),
      $(document.body).on('click.header', (e) => {
        if (!$(e.target).closest('.search-toggle-button').length) {
          $('.search-toggle-button').removeClass('open');
        }
      }),
    ];
  }

  _unbindEvents() {
    if (this.events) {
      this.events.forEach(event => event.off('.header'));
    }
  }

  _initCurrency() {
    const { currencySettings } = this.data;

    const switcherSelector = '[data-currency-converter]';
    CurrencyConverter.init({
      switcherSelector,
      priceSelector: '.money',
      shopCurrency: currencySettings.shopCurrency,
      defaultCurrency: currencySettings.defaultCurrency,
      displayFormat: currencySettings.displayFormat,
      moneyFormat: currencySettings.moneyFormat,
      moneyFormatNoCurrency: currencySettings.moneyFormatNoCurrency,
      moneyFormatCurrency: currencySettings.moneyFormatCurrency,
    });

    this.currencyWrapper = $('.selected-currency', this.$el);
    this.currencyWrapper.text($(switcherSelector).val());

    // convert everything to ensure all .money elements on page have been converted.
    this._setCurrency($(switcherSelector).val());

    this.events.push($(switcherSelector, this.$el).on('change.header', event => this._setCurrency(event.currentTarget.value)));
  }

  _setCurrency(value) {
    CurrencyConverter.setCurrency(value);
    this.currencyWrapper.text(value);
  }

  prepareRemove() {
    this._unbindEvents();
  }
}
